import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';
import { ContentSection, ContentSectionItem } from './ContentSection.styles';

interface PopoverContainerProps {
  x?: number;
  y?: number;
  hasAttributes?: boolean;
  placement?: 'top' | 'bottom';
}

export const PopoverContainer = styled(Box).attrs(({ theme }) => ({
  bg: theme.colors.background,
  borderColor: theme.colors.heavyLineOutline,
  borderRadius: '5px',
}))<PopoverContainerProps>`
  border: 1px solid;
  box-shadow: 0 4px 12px ${({ theme }) => theme.colors.boxShadow};
  position: absolute;
  z-index: 1000;
  backdrop-filter: blur(8px);
  transition: all 0.2s ease-in-out;
  width: 320px;
  height: auto;
  transform: ${({ placement }) =>
    placement === 'bottom' ? 'translate(-50%, 0%)' : 'translate(-50%, -100%)'};
  margin-top: ${({ placement }) => (placement === 'bottom' ? '10px' : '-10px')};
  left: ${({ x }) => (x ? `${x}px` : '0')};
  top: ${({ y }) => (y ? `${y}px` : '0')};

  &:hover {
    box-shadow: 0 6px 16px ${({ theme }) => theme.colors.boxShadow};
  }

  /* Hide scrollbars but keep scrolling (cross-browser) */
  /* Firefox */
  &,
  & * {
    scrollbar-width: none; /* hides scrollbar but keeps scroll */
    -ms-overflow-style: none; /* IE 10+ */
  }

  /* WebKit */
  & *::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
  }
  & *::-webkit-scrollbar-track {
    background: transparent !important;
  }
  & *::-webkit-scrollbar-thumb {
    background: transparent !important;
  }
`;

export const HeaderSection = styled(Box).attrs(({ theme }) => ({
  bg: theme.colors.background,
  p: '12px 12px 0',
  mb: 3,
}))`
  position: sticky;
  top: 0;
  z-index: 2;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

export const AttributeRow = styled(Box).attrs({
  py: 2,
  px: 2,
  height: '100%',
  horizontal: true,
  justify: 'space-between',
  align: 'center',
})`
  display: grid;
  grid-template-columns: 35% 65%;
  align-items: center;
  column-gap: 8px;
  & > * {
    min-width: 0;
  }
  & > *:nth-child(1) {
    overflow-wrap: break-word;
    word-break: normal;
    white-space: normal;
    hyphens: auto;
  }
  & > *:nth-child(2) {
    overflow-wrap: break-word;
    word-break: break-all;
    white-space: normal;
  }
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;
export const HeaderAttributeRow = styled(AttributeRow)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > * {
    min-width: 0;
    overflow-wrap: break-word;
    word-break: normal;
    white-space: normal;
    hyphens: auto;
  }
  &:nth-child(even) {
    background-color: transparent;
  }
  &:last-child {
    padding-top: 2px;
    padding-bottom: 0;
  }
  &:first-child {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const SublayerTitle = styled(Box).attrs({
  mt: 2,
  py: 2,
  px: 3,
  height: '100%',
  horizontal: true,
  justify: 'space-between',
  align: 'center',
  borderRadius: '4px',
})`
  border: 1px solid;
  position: sticky;
  top: 0;
  zindex: 1;
`;

export { ContentSection, ContentSectionItem };

export const TitleTruncate = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
